import React from 'react';

import Button from '../Button';
import Modal from '../Modal';

interface IProps {
  modalIsOpen: boolean;
  toggleModalIsOpen: () => void;
  onRemove: () => void;
  resourceName: string;
}

export const RemoveModal = (props: IProps) => {
  const { modalIsOpen, toggleModalIsOpen, onRemove, resourceName } = props;

  return (
    <Modal
      onClose={toggleModalIsOpen}
      open={modalIsOpen}
      className="group-removal-modal"
      title={`DELETE ${resourceName.toUpperCase()}`}
      wideButton={true}
      actions={[
        <Button
          key="button-remove"
          fullWidth={true}
          onClick={onRemove}
          variant="contained"
          className="confirm-removal-button"
          color="primary"
        >
          YES, REMOVE THIS {`${resourceName.toUpperCase()}`}
        </Button>
      ]}
    >
      <p>{`Are you sure you want to remove this ${resourceName}?`}</p>
    </Modal>
  );
};
